import { clientEnv } from "#/env";
import { dropOpaqueScriptErrors } from "#/lib/posthogBeforeSend";

export function posthogClientOptions() {
  return {
    api_host: clientEnv.VITE_POSTHOG_HOST,
    defaults: "2026-05-30" as const,
    capture_exceptions: true,
    cookieless_mode: "on_reject" as const,
    opt_out_capturing_by_default: true,
    before_send: dropOpaqueScriptErrors,
    debug: false,
  };
}
